export var MessageActionStatusEnum;
(function (MessageActionStatusEnum) {
    MessageActionStatusEnum["PENDING"] = "pending";
    MessageActionStatusEnum["DONE"] = "done";
})(MessageActionStatusEnum || (MessageActionStatusEnum = {}));
